import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module table/tableproperties
 */
import { Plugin } from 'ckeditor5/src/core.js';
import TablePropertiesEditing from './tableproperties/tablepropertiesediting.js';
import TablePropertiesUI from './tableproperties/tablepropertiesui.js';
/**
 * The table properties feature. Enables support for setting properties of tables (size, border, background, etc.).
 *
 * Read more in the {@glink features/tables/tables-styling Table and cell styling tools} section.
 * See also the {@link module:table/tablecellproperties~TableCellProperties} plugin.
 *
 * This is a "glue" plugin that loads the
 * {@link module:table/tableproperties/tablepropertiesediting~TablePropertiesEditing table properties editing feature} and
 * the {@link module:table/tableproperties/tablepropertiesui~TablePropertiesUI table properties UI feature}.
 */
var TableProperties = /*#__PURE__*/function (_Plugin) {
  _inherits(TableProperties, _Plugin);
  var _super = _createSuper(TableProperties);
  function TableProperties() {
    _classCallCheck(this, TableProperties);
    return _super.apply(this, arguments);
  }
  _createClass(TableProperties, null, [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TableProperties';
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "requires",
    get: function get() {
      return [TablePropertiesEditing, TablePropertiesUI];
    }
  }]);
  return TableProperties;
}(Plugin);
export { TableProperties as default };